






















/*eslint-disable */
/* tslint:disable */
import { computed, defineComponent, Ref } from '@vue/composition-api';
import store                              from '@/store';


const ContrastSwitcher: object = defineComponent({
  name: 'ContrastSwitcher',
  props: {
    icon: {
      type: String,
      // eslint-disable-next-line global-require
      default: require('@/assets/img/top_icons/svg/icon-contrast-white.svg'),
    },
    iconhc: {
      type: String,
      // eslint-disable-next-line global-require
      default: require('@/assets/img/top_icons/svg/icon-contrast-yellow.svg'),
    },
  },
  setup() {
    const getContrastActive: Ref<boolean> = computed((): boolean => store.getters.getContrastActive);
    const handleContrastClick = () => store.commit('flipContrastActive');

    return {
      getContrastActive,
      handleContrastClick,
    };
  },
});
export default ContrastSwitcher;
